export const generateInvoiceName = (planName: string, appName: string) => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  const planNormalizedName = planName.replaceAll(/\s+/g, '');
  const appNormalizedName = appName.replaceAll(/\s+/g, '');
  return `${yyyy}${mm}${dd}_${planNormalizedName}_${appNormalizedName}.pdf`;
};
